import React from 'react';
import Logo from '../imagens/logo3.1.png';
import {withRouter} from 'react-router-dom';
import { Link } from 'react-router-dom';

class Header extends React.Component {
    render(){
        return(
            <nav className="navbar navbar-dark navbar-expand-md navbar-fixed-top bg-primary">
            <Link to="/" className="navbar-brand abs"><div className="row justify-content-center"><div className="col-md-4"><img className="Logo" src={Logo}></img></div></div></Link>
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsingNavbar">
                <span className="navbar-toggler-icon"></span>
            </button>
            <div className="navbar-collapse collapse" id="collapsingNavbar">
                <ul className="navbar-nav rightMargin">
                    <li className="nav-item">
                        <Link to="/empresa" className="nav-link">DONA MARIQUINHA</Link>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" href="/#produtos">PRODUTOS</a>
                    </li>
                </ul>
                <ul className="navbar-nav ml-auto leftMargin">
                    <li className="nav-item">
                        <Link to="/receitas" className="nav-link">RECEITAS E DICAS</Link>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" href="/#contato">CONTATO</a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" href="https://www.instagram.com/produtos_dona_mariquinha/"><i className="fab fa-instagram"></i></a>
                    </li>
                    <li className="nav-item fbCorrection">
                        <a className="nav-link" href="https://www.facebook.com/Distribuidora-Dona-Mariquinha-100742948089130"><i className="fab fa-facebook"></i></a>
                    </li>
                </ul>
            </div>
        </nav>
        )
    }
}

export default withRouter(Header);
